import { render, staticRenderFns } from "./FooterDetails.vue?vue&type=template&id=831a4a90&"
import script from "./FooterDetails.vue?vue&type=script&lang=js&"
export * from "./FooterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports